import { all } from "redux-saga/effects";
import account from "./account/sagas";
import port from "./port/sagas";
import connection from "./connection/sagas";
import block from "./block/sagas";
import channel from "./channel/sagas";
import user from "./user/sagas";
import monitoring from "./monitoring/sagas";
import widget from "./widget/sagas";
import widgetChannel from "./widgetChannel/sagas";
import widgetState from "./widgetState/sagas";
import history from "./history/sagas";
import dashboard from "./dashboard/sagas";
import jwt from "./jwt/sagas";
import setting from "./setting/sagas";
import tagGroup from "./tagGroup/sagas";
import session from "./session/sagas";
import credential from "./credential/sagas";
import bucket from "./bucket/sagas";
import gauge from "./gauge/sagas";
import license from "./license/sagas";
import healthCheck from "./healthCheck/sagas";
import displayProfile from "./displayProfile/sagas";
import monitoringDisplayProfile from "./monitoringDisplayProfile/sagas";
import widgetChannelState from "./widgetChannelState/sagas";

export default function* rootSaga() {
  yield all([
    account(),
    port(),
    connection(),
    block(),
    channel(),
    user(),
    monitoring(),
    widget(),
    widgetChannel(),
    widgetState(),
    history(),
    dashboard(),
    jwt(),
    setting(),
    tagGroup(),
    session(),
    credential(),
    bucket(),
    gauge(),
    license(),
    healthCheck(),
    displayProfile(),
    monitoringDisplayProfile(),
    widgetChannelState(),
  ]);
}
